import { CatalogSource, SupportedCatalogSourceType } from './catalog-source';

export default class WarehouseCatalogSource extends CatalogSource {
	getType() {
		return SupportedCatalogSourceType.warehouse;
	}
	getTypeOptionGroupName() {
		return 'Fabric Data Warehouse Option Group';
	}
}
